import { DataHeader, DataSource, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommGroup extends Layout {
    dataheaderMobileCommUnit: DataHeader;
    labelLimitedView: Switch;
    panelMobileCommUnit: Panel;
    sourceMCGroup: DataSource;
    textboxAddress: Textbox;
    textboxDescr: Textbox;
    textboxName: Textbox;
    textboxVendor: Textbox;
}
